export default class ModalsManager {
  /* @ngInject */
  constructor($uibModal) {
    this.$uibModal = $uibModal;
  }

  openCostModalPricing(editMode, cost) {
    return this.$uibModal
      .open({
        animation: true,
        backdrop: "static",
        component: "costModalPricing",
        size: "lg",
        resolve: {
          editMode: () => editMode,
          cost: () => cost,
        },
      })
      .result.catch(() => false);
  }

  openChangeOrganizationModal() {
    return this.$uibModal
      .open({
        animation: true,
        backdrop: "static",
        component: "changeOrganizationModal",
      })
      .result.catch(() => false);
  }

  openContactModal(contact, editMode) {
    return this.$uibModal
      .open({
        animation: true,
        backdrop: "static",
        component: "contactModal",
        size: "lg",
        resolve: {
          editMode: () => editMode,
          contact: () => contact,
        },
      })
      .result.catch(() => null);
  }

  openCostFolderModal(costFolder) {
    return this.$uibModal
      .open({
        animation: true,
        backdrop: "static",
        component: "costFolderModal",
        resolve: {
          costFolder: () => costFolder,
        },
      })
      .result.catch(() => null);
  }

  openCostModal(cost) {
    return this.$uibModal
      .open({
        animation: true,
        backdrop: "static",
        component: "costModal",
        resolve: {
          cost: () => cost,
        },
      })
      .result.catch(() => null);
  }

  openImageSelectorModal() {
    return this.$uibModal
      .open({
        animation: true,
        backdrop: "static",
        size: "lg",
        component: "imageSelectorModal",
      })
      .result.catch(() => null);
  }

  openMoveCostModal(costFolderOrCost) {
    return this.$uibModal
      .open({
        animation: true,
        backdrop: "static",
        component: "moveCostModal",
        resolve: {
          costFolderOrCost: () => costFolderOrCost,
        },
      })
      .result.catch(() => false);
  }

  openImportCostsCsvModal() {
    return this.$uibModal
      .open({
        animation: true,
        backdrop: "static",
        component: "importCostsCsvModal",
      })
      .result.catch(() => false);
  }

  openCreateQuoteVersionModal(quote) {
    return this.$uibModal
      .open({
        animation: true,
        backdrop: "static",
        component: "createQuoteVersionModal",
        resolve: {
          quote: () => quote,
        },
      })
      .result.catch(() => null);
  }

  openPlaceholderModal(quoteLanguage) {
    return this.$uibModal
      .open({
        animation: true,
        backdrop: "static",
        size: "lg",
        component: "placeholderModal",
        resolve: {
          quoteLanguage: () => quoteLanguage,
        },
      })
      .result.catch(() => null);
  }

  openPricingTableModal(params) {
    return this.$uibModal
      .open({
        animation: true,
        backdrop: "static",
        size: "full",
        component: "pricingTableModal",
        keyboard: false,
        resolve: {
          pricingTable: () => params.pricingTable,
          onChangePricingTable: () => params.onChangePricingTable,
          existCostWithDifferentCurrency: () => params.existCostWithDifferentCurrency,
          updatedRatesLastDate: () => params.updatedRatesLastDate,
          areRatesUpdated: () => params.areRatesUpdated,
          updateRates: () => params.updateRates,
        },
      })
      .result.catch(() => false);
  }

  openQuoteHeaderModal(params) {
    return this.$uibModal
      .open({
        animation: true,
        backdrop: "static",
        size: "full",
        component: "quoteHeaderModal",
        resolve: {
          params: () => params,
        },
      })
      .result.catch(() => null);
  }

  openQuoteSectionNameModal(sectionName) {
    return this.$uibModal
      .open({
        animation: true,
        backdrop: "static",
        component: "quoteSectionNameModal",
        resolve: {
          sectionName: () => sectionName,
        },
      })
      .result.catch(() => null);
  }

  openQuoteShareModal(quote, shareByDefault) {
    return this.$uibModal
      .open({
        animation: true,
        backdrop: "static",
        size: "lg",
        component: "quoteShareModal",
        resolve: {
          quote: () => quote,
          shareByDefault: () => shareByDefault,
        },
      })
      .result.catch(() => false);
  }

  openQuoteTemplateShareModal(quoteTemplate, shareByDefault) {
    return this.$uibModal
      .open({
        animation: true,
        backdrop: "static",
        component: "quoteTemplateShareModal",
        resolve: {
          quoteTemplate: () => quoteTemplate,
          shareByDefault: () => shareByDefault,
        },
      })
      .result.catch(() => false);
  }

  openQuoteTemplateEditNameModal(quoteTemplateName) {
    return this.$uibModal
      .open({
        animation: true,
        backdrop: "static",
        component: "quoteTemplateEditNameModal",
        resolve: {
          quoteTemplateName: () => quoteTemplateName,
        },
      })
      .result.then((response) => response)
      .catch(() => false);
  }

  openQuoteTemplateImportModal() {
    return this.$uibModal
      .open({
        animation: true,
        backdrop: "static",
        component: "quoteTemplateImportModal",
      })
      .result.then((response) => response)
      .catch(() => false);
  }

  openQuoteTemplateCreateOverwriteModal(quoteId) {
    return this.$uibModal
      .open({
        animation: true,
        backdrop: "static",
        component: "quoteTemplateCreateOverwriteModal",
        size: "lg",
        resolve: {
          quoteId: () => quoteId,
        },
      })
      .result.catch(() => null);
  }

  openSectionGalleryModal() {
    return this.$uibModal
      .open({
        animation: true,
        backdrop: "static",
        component: "sectionGalleryModal",
      })
      .result.catch(() => null);
  }

  openSelectCostModal() {
    return this.$uibModal
      .open({
        animation: true,
        backdrop: "static",
        size: "lg",
        component: "selectCostModal",
      })
      .result.catch(() => null);
  }
}
